import PropTypes from 'prop-types';
import React from 'react';

import useFormValidation from './useFormValidation.ts';
import type { InferPropTypes } from '../typings/index.ts';

const propTypes = {
  isValid: PropTypes.bool.isRequired,
  children: PropTypes.element
};
const defaultProps = {
  children: null
};

export type FormIsValidProps = InferPropTypes<typeof propTypes, typeof defaultProps>;

const FormIsValid: React.FC<FormIsValidProps> = ({ isValid, children }) => {
  useFormValidation(isValid);
  return children || null;
};

FormIsValid.propTypes = propTypes;
FormIsValid.defaultProps = defaultProps;
export default FormIsValid;
